var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    {
      staticClass: "veneer-log",
      attrs: { square: "", flat: "", bordered: "" }
    },
    [
      _c(
        "q-card-section",
        { staticClass: "q-pa-none" },
        [
          !_vm.emitLog
            ? _c(
                "router-link",
                { attrs: { to: _vm.detailLink } },
                [
                  _c("log-teaser", {
                    attrs: {
                      log: _vm.log,
                      "watchlist-item": _vm.watchlistItem,
                      "is-public": _vm.isPublic
                    }
                  })
                ],
                1
              )
            : _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.$emit("click", _vm.log)
                    }
                  }
                },
                [
                  _c("log-teaser", {
                    attrs: {
                      log: _vm.log,
                      "watchlist-item": _vm.watchlistItem,
                      "is-public": _vm.isPublic
                    }
                  })
                ],
                1
              )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "q-card-section",
        { staticClass: "veneer-log-info-section q-py-none" },
        [
          _c(
            "veneer-log-info",
            {
              attrs: {
                log: _vm.log,
                "is-public": _vm.isPublic,
                virtual: _vm.virtual,
                dense: ""
              }
            },
            [_vm._t("additionalInfo")],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("q-separator"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "row justify-start q-col-gutter-sm q-pa-sm veneer-card-buttons"
        },
        [
          _c(
            "div",
            { staticClass: "col-4" },
            [
              _c("q-btn", {
                attrs: {
                  color: "primary",
                  size: "11px",
                  to: _vm.detailLink,
                  icon: "visibility",
                  "no-caps": "",
                  "no-wrap": "",
                  label: _vm.$t("button.detailView")
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-4" },
            [
              _vm.measurementListDialog
                ? _c("q-btn", {
                    attrs: {
                      "text-color": "primary",
                      size: "11px",
                      icon:
                        "img:\\typo3conf\\ext\\ig_warehouse\\Resources\\Public\\Icons\\tally-sheet.png",
                      "no-caps": "",
                      "no-wrap": "",
                      flat: "",
                      label: _vm.$t("button.measurementList")
                    },
                    on: {
                      click: function($event) {
                        return _vm.showMeasurementListDialog(
                          _vm.log,
                          _vm.virtual,
                          _vm.watchlistItem
                        )
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-4" },
            [
              _vm.watchlistDialog && _vm.user && !_vm.isPublic
                ? _c("q-btn", {
                    attrs: {
                      "text-color": "primary",
                      size: "11px",
                      icon: _vm.watchIcon,
                      "no-caps": "",
                      "no-wrap": "",
                      flat: "",
                      label: _vm.$t("button.watch")
                    },
                    on: {
                      click: function($event) {
                        return _vm.showWatchlistDialog(_vm.log, _vm.virtual)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.user ? _vm._t("additionalActions") : _vm._e(),
          _vm._v(" "),
          _vm.user &&
          ((_vm.virtualLog && !_vm.virtual) || (!_vm.isPublic && _vm.virtual))
            ? [
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _vm.virtualLog && !_vm.virtual
                      ? _c("q-btn", {
                          attrs: {
                            "text-color": "primary",
                            size: "11px",
                            icon: "add",
                            "no-caps": "",
                            "no-wrap": "",
                            flat: "",
                            label: _vm.$t("button.addToVirtualLog")
                          },
                          on: {
                            click: function($event) {
                              return _vm.addToVirtualLog(_vm.log)
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _vm.virtual
                      ? _c("q-btn", {
                          attrs: {
                            "text-color": "primary",
                            size: "11px",
                            icon: "edit",
                            "no-caps": "",
                            "no-wrap": "",
                            flat: "",
                            label: _vm.$t("button.edit")
                          },
                          on: {
                            click: function($event) {
                              return _vm.editVirtualLog(
                                _vm.log,
                                _vm.watchlistItem
                              )
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }